"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_MESSAGE_BACK = void 0;
exports["default"] = sendMessageback;
var SEND_MESSAGE_BACK = 'WEB_CHAT/SEND_MESSAGE_BACK';
exports.SEND_MESSAGE_BACK = SEND_MESSAGE_BACK;
function sendMessageback(value, text, displayText) {
  return {
    type: SEND_MESSAGE_BACK,
    payload: {
      displayText: displayText,
      text: text,
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRU5EX01FU1NBR0VfQkFDSyIsImV4cG9ydHMiLCJzZW5kTWVzc2FnZWJhY2siLCJ2YWx1ZSIsInRleHQiLCJkaXNwbGF5VGV4dCIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2VuZE1lc3NhZ2VCYWNrLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNFTkRfTUVTU0FHRV9CQUNLID0gJ1dFQl9DSEFUL1NFTkRfTUVTU0FHRV9CQUNLJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2VuZE1lc3NhZ2ViYWNrKHZhbHVlLCB0ZXh0LCBkaXNwbGF5VGV4dCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNFTkRfTUVTU0FHRV9CQUNLLFxuICAgIHBheWxvYWQ6IHsgZGlzcGxheVRleHQsIHRleHQsIHZhbHVlIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VORF9NRVNTQUdFX0JBQ0sgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLGlCQUFpQixHQUFHLDRCQUE0QjtBQUFDQyxPQUFBLENBQUFELGlCQUFBLEdBQUFBLGlCQUFBO0FBRXhDLFNBQVNFLGVBQWVBLENBQUNDLEtBQUssRUFBRUMsSUFBSSxFQUFFQyxXQUFXLEVBQUU7RUFDaEUsT0FBTztJQUNMQyxJQUFJLEVBQUVOLGlCQUFpQjtJQUN2Qk8sT0FBTyxFQUFFO01BQUVGLFdBQVcsRUFBWEEsV0FBVztNQUFFRCxJQUFJLEVBQUpBLElBQUk7TUFBRUQsS0FBSyxFQUFMQTtJQUFNO0VBQ3RDLENBQUM7QUFDSCJ9